<template>
    <div class="cell-buttons-wrapper">
      <div class="cell-buttons">
        <a href="#" class="cell-button" :class="{'disabled': !active}">
          <vs-button
            size="small"
            :color="borderColour"
            type="border"
            :disabled="!active"
            :style="`background:${backgroundColour} !important`"
            @click="clicked"
          >
            <span :style="`color:${fontColour}`">{{ buttonTxt }}</span>
          </vs-button>
        </a>
      </div>
    </div>
</template>

<script>
export default {
  name: 'CellRendererButton',
  computed: {
    active() {
      return this.params.active || false;
    },
    backgroundColour() {
      return this.params.backGroundColour || 'transparent';
    },
    borderColour() {
      return this.params.borderColour || 'black';
    },
    fontColour() {
      return this.params.fontColour || 'black';
    },
    buttonTxt() {
      return this.params.buttonTxt;
    },
    column() {
      return this.params.column;
    },
    confirmAction() {
      return this.params.confirmAction;
    },
    confirmActionMessage() {
      return this.params.confirmActionMessage;
    },
    itemId() {
      return this.params.itemId;
    }
  },
  methods: {
    clicked() {
      const { confirmAction, confirmActionMessage, itemId } = this.params;

      this.$parent.$emit('apiAction', {
        confirmAction,
        confirmActionMessage,
        itemId,
      });
    }
  }
}
</script>

<style lang="scss">
  @import '@/assets/scss/custom/components/variables';
  .cell-buttons-wrapper {
    height: 100%;
    display: flex;
    align-items: center;

    .cell-buttons {
      .cell-button {
        &.disabled {
          cursor: initial;
        }

        > button:hover {
          background-color: #fff !important;
        }  
      }

      button {
        padding: 2.5px 7px !important;

        span {
          font-size: 12px;
        }
      }
    }
  }
</style>
